<script>
const op = [
  // {
  //   name: "家得福-海棠店",
  //   val: 0
  // },
  // {
  //   name: "家得福-中央华府店",
  //   val: 1
  // },
  // {
  //   name: "家得福-海洲店",
  //   val: 2
  // },
  // {
  //   name: "家得福-西小区店",
  //   val: 3
  // },
  // {
  //   name: "家得福-海宁店",
  //   val: 4
  // },
  // {
  //   name: "家得福-百合园店",
  //   val: 5
  // },
  // {
  //   name: "家得福-供电局店",
  //   val: 6
  // },
  // {
  //   name: "家得福-水木华园店",
  //   val: 7
  // }
];
const opt = [
  {
    name: "容易",
    val: 1
  },
  {
    name: "一般",
    val: 2
  },
  {
    name: "较难",
    val: 3
  }
];
const options = [
  {
    name: "创建中",
    val: 0
  },
  {
    name: "待审批",
    val: 1
  },
  {
    name: "审批通过",
    val: 2
  },
  {
    name: "下架",
    val: 3
  }
];
const typeObj = [
  {
    name: "全部",
    val: ""
  },
  {
    name: "未付款",
    val: "0"
  },
  {
    name: "已付款",
    val: "1"
  }
];
const typeObjs1 = [
  {
    name: "全部",
    val: ""
  },
  {
    name: "未阅",
    val: 1
  },
  {
    name: "已阅",
    val: 2
  }
];
const typeObjs = [
  {
    name: "全部",
    val: ""
  },
  {
    name: "待审核",
    val: 1
  },
  {
    name: "审核通过",
    val: 2
  },
  {
    name: "审核不通过",
    val: 3
  }
];
const cities = [
  {
    name: "私募课程",
    val: 1
  },
  {
    name: "免费课程",
    val: 0
  }
];
const courseTags = [
  {
    name: "独立课程",
    val: 1
  },
  {
    name: "章节课程",
    val: 2
  }
  // {
  //   name: "推荐课程",
  //   val: 3
  // },
  // {
  //   name: "社招课程",
  //   val: 4
  // }
];
const opts = [
  {
    name: "视频文件",
    val: 0
  },
  {
    name: "其他文件",
    val: 1
  },
  {
    name: "音频文件",
    val: 2
  }
];
const notifyOpts = [
  {
    name: "通知公告",
    val: 1
  },
  {
    name: "个人消息",
    val: 2
  },
  {
    name: "考试资讯",
    val: 3
  },
  {
    name: "新闻资讯",
    val: 4
  },
  {
    name: "企业文化",
    val: 5
  },
  {
    name: "企业微信消息",
    val: 6
  }
];

const status = [
  {
    name: "禁用",
    val: 0
  },
  {
    name: "启用",
    val: 1
  },
  {
    name: "已发送",
    val: 2
  },
  {
    name: "发送失败",
    val: 3
  },
  {
    name: "已撤回",
    val: 4
  }
];
const notifyType = [
  {
    name: "通知公告",
    val: 1
  },
  {
    name: "个人消息",
    val: 2
  },
  {
    name: "考试资讯",
    val: 3
  },
  {
    name: "新闻资讯",
    val: 4
  },
  {
    name: "企业文化",
    val: 5
  },
  {
    name: "企业微信消息",
    val: 6
  }
];
const tys = [
  {
    name: "已清空",
    val: 0
  },
  {
    name: "消息",
    val: 1
  },
  {
    name: "警告",
    val: 2
  },
  {
    name: "次要",
    val: 3
  },
  {
    name: "主要",
    val: 4
  },
  {
    name: "紧急",
    val: 5
  },
  {
    name: "全部",
    val: ""
  }
];
const ty = [
  {
    name: "已清除",
    val: 0
  },
  {
    name: "未解决",
    val: 1
  }
];
const typ = [
  {
    value: 1,
    label: "维护"
  },
  {
    value: 2,
    label: "维修"
  }
];
const types = [
  {
    value: 1,
    label: "未派发"
  },
  {
    value: 2,
    label: "已派发"
  },
  {
    value: 3,
    label: "已完成"
  }
];
const tyop = [
  {
    name: "判断题",
    val: 1
  },
  {
    name: "单选题",
    val: 2
  },
  {
    name: "多选题",
    val: 3
  },
  {
    name: "填空题",
    val: 4
  }
]; const tyops = [
  {
    name: "判断题",
    val: 1
  },
  {
    name: "单选题",
    val: 2
  },
  {
    name: "多选题",
    val: 3
  },

];
const abc = [
  {
    name: "不颁发证书",
    val: 0
  },
  {
    name: "自动颁发证书",
    val: 1
  },
  {
    name: "手动颁发证书",
    val: 2
  }
];
const planPatternobj = [
  {
    name: "不颁发证书",
    val: 0
  },
  {
    name: "自动颁发证书",
    val: 1
  },
  {
    name: "手动颁发证书",
    val: 2
  }
];
const ab = [
  {
    name: "全部",
    val: ""
  },
  {
    name: "未开始",
    val: "0"
  },
  {
    name: "进行中",
    val: "1"
  },
  {
    name: "已结束",
    val: "2"
  }
];
const abd = [
  {
    name: "全部",
    val: ""
  },
  {
    name: "未开始",
    val: 1
  },
  {
    name: "进行中",
    val: 2
  },
  {
    name: "已结束",
    val: 3
  }
];
const ac = [
  {
    name: "单选题",
    val: 1
  },
  {
    name: "多选题",
    val: 2
  },
  {
    name: "判断题",
    val: 3
  },

  {
    name: "填空题",
    val: 4
  },
  {
    name: "问答题",
    val: 5
  }
];
const ol = [
  {
    name: "公开试题",
    val: 1
  },
  {
    name: "考试专用试题",
    val: 2
  }
];
const statusyupe = [
  {
    name: "未开始",
    val: 1
  },
  {
    name: "进行中",
    val: 2
  },
  {
    name: "已结束",
    val: 3
  }
];
const pin = [
  {
    name: "整页显示题目",
    val: 1
  },
  {
    name: "单题显示",
    val: 2
  }
];
const switchs = [
  {
    name: "不允许切换屏幕",
    val: 2
  },
  {
    name: "允许切换屏幕",
    val: 1
  }
];
const tryorder = [
  {
    name: "按题型排序",
    val: 3
  },
  {
    name: "随机顺序",
    val: 2
  },
  {
    name: "原始顺序",
    val: 1
  }
];

const slideshowmodel = [
  {
    name: "移动端",
    val: 2
  },
  {
    name: "PC端",
    val: 1
  }
];

const sexop = [
  {
    name: "女",
    val: 2
  },
  {
    name: "男",
    val: 1
  }
];

const userstatusop = [
  {
    name: "离职",
    val: 2
  },
  {
    name: "在职",
    val: 1
  }
];

const useruseop = [
  {
    name: "禁用",
    val: 2
  },
  {
    name: "启用",
    val: 1
  }
];


const studenttype = [
  {
    name: "学生",
    val: 1
  },
  {
    name: "老师",
    val: 2
  }
];
const isopen = [
  {
    name: "否",
    val: 0
  },
  {
    name: "是",
    val: 1
  }
];

export default {
  op, //用户地址
  opt,
  options,
  typeObj,
  isopen,
  typeObjs,
  typeObjs1,
  cities,
  courseTags,
  opts,
  notifyOpts, tyops,
  tys,
  ty,
  typ,
  types,
  tyop,
  abc,
  planPatternobj,
  ab,
  ac,
  ol,
  statusyupe,
  pin,
  switchs,
  tryorder,
  slideshowmodel,
  sexop,
  userstatusop,
  useruseop,
  studenttype,
  status,
  notifyType,
  abd
};
</script>



// WEBPACK FOOTER //
// src/views/components/Global.vue